// extracted by mini-css-extract-plugin
export default {"arrow":"DeliveryStatus_arrow__TJus0","mail-order":"DeliveryStatus_mail-order__Vn0k1","motoboy-order":"DeliveryStatus_motoboy-order__Dtse2"};